export const langs = __CONFIG__.languages
export const sections = __CONFIG__.sections
